import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationExtras,
  CanActivate,
} from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { redirectToLogin } from '../util/auth-redirect';
import { ApiResponse } from '../models/app.model';
// import { CommonService } from './common.service';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { TokenRefreshService } from './token-refresh.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  isLogged: boolean = false;
  redirectUrl: string = '';
  constructor(
    private auth: AuthService,
    private router: Router,
    private commonService: CommonService,
    private tokenRefreshService: TokenRefreshService
  ) {}

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ): Observable<boolean> | Promise<boolean> | boolean {
  //   this.commonService.setIsCallingApi(true);
  //   return new Promise((resp) => {
  //     this.auth.validateToken().subscribe(
  //       (res: ApiResponse) => {
  //         this.commonService.setIsCallingApi(false);
  //         if (res.isSuccessful) {
  //           //do nothing
  //         } else {
  //           localStorage.clear();
  //         }
  //         return resp(this.tokenHandling(route, state));
  //       },
  //       (error: HttpErrorResponse) => {
  //         this.commonService.setIsCallingApi(false);
  //         if (error.status === 401 || error.status === 403) {
  //           localStorage.clear();
  //           return resp(this.tokenHandling(route, state));
  //         }
  //       }
  //     );
  //   });
  // }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const token = localStorage.getItem('access_token');

    if (!token) {
      redirectToLogin();
      return false;
    }

    // Load user info before allowing route activation
    return this.auth.loadUserInfo().pipe(
      map((user) => {
        if (!user) {
          redirectToLogin();
          return false;
        }
        return true;
      }),
      catchError(() => {
        redirectToLogin();
        return of(false);
      })
    );
  }

  // splitByString(source, splitBy) {
  //     var splitter = splitBy.split('');
  //     splitter.push([source]); //Push initial value

  //     return splitter.reduceRight(function (accumulator, curValue) {
  //         var k = [];
  //         accumulator.forEach(v => k = [...k, ...v.split(curValue)]);
  //         return k;
  //     });
  // }
}
